module.exports = __webpack_public_path__ + "img/bg_top.c4409ca.jpg";